import { useState, useEffect } from 'react';
import {
   Download, Plus
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ALL_TABS = [
  { label: "Overview", key: "overview" },
  { label: "Members", key: "members" },
  { label: "Test Ride Bookings", key: "tasks" },
  { label: "Dealer Forms", key: "dealers" },
  { label: "Contact Forms", key: "contacts" },
  { label: "Bookings", key: "bookings" },
  { label: "Price Forms", key: "priceforms" },
  { label: "Payments", key: "payments" },
  { label: "Applications", key: "applications" },
  { label: "Career Postings", key: "careers" },
  { label: "Audit Logs", key: "auditlogs" },
  { label: "SEO Schema", key: "seoschema" },
  { label: "Hero Banner", key: "herobanner" },
  { label: "Vehicles", key: "vehicles" },
  { label: "Section Manager", key: "sectionmanager" },
  { label: "Page Editor", key: "pageeditor" }
];

export default function Members() {
    const [members, setMembers] = useState([]);
    const navigate = useNavigate();

    const [selectedUser, setSelectedUser] = useState(null);
const [showDialog, setShowDialog] = useState(false);
const [selectedTabs, setSelectedTabs] = useState([]);

const openAccessDialog = async (user) => {
  setSelectedUser(user);

  // 🔥 fetch existing tabs from backend
  const res = await fetch(`/api/user-tabs/${user.id}`);
  const data = await res.json();

  setSelectedTabs(data.tabs || []);
  setShowDialog(true);
};

const toggleTab = (tabKey) => {
  if (selectedTabs.includes(tabKey)) {
    setSelectedTabs(selectedTabs.filter(t => t !== tabKey));
  } else {
    setSelectedTabs([...selectedTabs, tabKey]);
  }
};

    useEffect(() => {
        const fetchMembers = async() => {
            const res = await fetch('/api/getmembers');
            const data = await res.json();
            console.log("data", res);
            setMembers(data);
        };
        fetchMembers();
    }, []);

    const handleAdd = () => {
        navigate('/addmember');
    } 


 const saveAccess = async () => {
  await fetch(`/api/user-tabs/${selectedUser.id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      tabs: selectedTabs
    })
  });

  setShowDialog(false);
};

 return (
      <div className="table-content">
            <div className="content-header">
              <div>
                <h2>User Management</h2>
                <p>Manage your team members and their permissions</p>
              </div>
              <div className="header-actions">
                <button className="secondary-btn">
                  <Download size={18} />
                  Export
                </button>
                <button className="primary-btn" onClick={() => handleAdd()}>
                  <Plus size={18} />
                  Add Member
                </button>
              </div>
            </div>
            <div className="table-container">
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Role</th>
                    {/* <th>Status</th> */}
                    <th>Joined Date</th>
                    <th>Tab Access</th>
                    {/* <th>Actions</th> */}
                  </tr>
                </thead>
                <tbody>
                  {members.map(user => (
                    <tr key={user.id}>
                      <td>
                        <div className="user-cell">
                          <div className="user-avatar-small">{user.name.split(' ').map(n => n[0]).join('')}</div>
                          <span>{user.name}</span>
                        </div>
                      </td>
                      <td>{user.email}</td>
                      <td><span className="role-badge">{user.role}</span></td>
                      {/* <td><span className={`status-badge ${user.status.toLowerCase()}`}>{user.status}</span></td> */}
                      {/* <td>{user.joinedDate}</td> */}
                     <td>
  {new Date(user.joinedDate).toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  })}
</td>
<td>
  <button
    className="secondary-btn"
    onClick={() => openAccessDialog(user)}
  >
    Manage Access
  </button>
</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          
       {showDialog && (
  <div className="dialog-overlay">
    <div className="dialog-box">
      <h3>Assign Tab Access</h3>

      <div className="tabs-list">
        {ALL_TABS.map(tab => (
          <label key={tab.key} className="checkbox-row">
            <input
              type="checkbox"
              checked={selectedTabs.includes(tab.key)}
              onChange={() => toggleTab(tab.key)}
            />
            {tab.label}
          </label>
        ))}
      </div>

      <div className="dialog-actions">
        <button onClick={() => setShowDialog(false)}>Cancel</button>
        <button onClick={saveAccess}>Save</button>
      </div>
    </div>
  </div>
)}   
          </div>

    
)
}